<template>
    <iframe
        style="width: 100%; height: 84vh; border: 0; padding-top: 10px"
        :src="workflowUrl"
    />
</template>
<script>
import { WORKFLOW_UI } from "@/config";

export default {
    data() {
        return {
            task: "",
            version: "",
            token: null,
        };
    },
    computed: {
        workflowUrl() {
            const baseUrl = `${WORKFLOW_UI}/workflows/${this.task}/${this.version}?flat=true`;
            return this.token ? `${baseUrl}&auth=${this.token}` : baseUrl;
        },
    },
    created() {
        this.task = this.$route.params.task;
        this.version = this.$route.params.version;
        const userData = sessionStorage.getItem("userLogin");
        this.token = userData ? JSON.parse(userData).token : null;
    },
};
</script>
